<h1 mat-dialog-title class="dialog-title">Delete this crop?</h1>

<p>Are you sure you want to delete this crop?</p>
<p>This action cannot be undone.</p>

<div mat-dialog-actions class="action-buttons horizontal">
  <button mat-button (click)="onClose()" class="secondary-button">Cancel</button>
  <button mat-button (click)="onDeleteCrop()" class="primary-button">Delete</button>
</div>